import React from 'react';
import * as BS from 'react-bootstrap';
import * as BSEx from '../../BootstrapExtends';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { dateToString, stringToDate } from '../../../lib/DateUtils';

import 'react-datepicker/dist/react-datepicker.css';

const propTypes = {
  startDateLabel: PropTypes.string,
  endDateLabel: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  errors: PropTypes.instanceOf(Object),
  touched: PropTypes.instanceOf(Object),
  onChangeStartDate: PropTypes.func,
  onChangeEndDate: PropTypes.func,
  onBlurStartDate: PropTypes.func,
  onBlurEndDate: PropTypes.func,
};

const DateRangePicker = ({
  startDateLabel,
  endDateLabel,
  startDate,
  endDate,
  errors,
  touched,
  onChangeStartDate,
  onChangeEndDate,
  onBlurStartDate,
  onBlurEndDate,
}) => {
  const startDateObj = stringToDate(startDate);
  const endDateObj = stringToDate(endDate);

  return (
    <BSEx.FormGroup>
      <BS.Col sm={6}>
        {/* start date */}
        <BSEx.FormGroupInline
          label={startDateLabel}
          labelColProps={{ sm: 4 }}
          childrenColProps={{ sm: 6 }}
          error={errors.startDate}
          touched={touched.startDate}
        >
          <DatePicker
            selected={startDateObj}
            onChange={(date) => {
              const dateString = dateToString(date);
              onChangeStartDate(dateString);
              // If end date exists and is earlier than new start date, update end date
              if (endDateObj && date > endDateObj) {
                onChangeEndDate(dateToString(date));
              }
            }}
            onBlur={() => {
              if (onBlurStartDate) {
                onBlurStartDate();
              }
            }}
            selectsStart
            startDate={startDateObj}
            endDate={endDateObj}
            dateFormat='yyyy-MM-dd'
            customInput={<BS.FormControl type='text' />}
          />
        </BSEx.FormGroupInline>
      </BS.Col>

      <BS.Col sm={6}>
        {/* end date */}
        <BSEx.FormGroupInline
          label={endDateLabel}
          labelColProps={{ sm: 4 }}
          childrenColProps={{ sm: 6 }}
          error={errors.endDate}
          touched={touched.endDate}
        >
          <DatePicker
            selected={endDateObj}
            onChange={(date) => {
              const dateString = dateToString(date);
              onChangeEndDate(dateString);
            }}
            onBlur={() => {
              if (onBlurEndDate) {
                onBlurEndDate();
              }
            }}
            selectsEnd
            startDate={startDateObj}
            endDate={endDateObj}
            minDate={startDateObj}
            dateFormat='yyyy-MM-dd'
            customInput={<BS.FormControl type='text' />}
          />
        </BSEx.FormGroupInline>
      </BS.Col>
    </BSEx.FormGroup>
  );
};

DateRangePicker.propTypes = propTypes;

export default DateRangePicker;
